import { useState } from "react";
import {
    IconButton, Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField,
    Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper
} from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { FPagarItemStyle } from "./FPagarItemStyles";
import { useFormik } from "formik";
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import { useDispatch } from "react-redux";
import { pagarCompraIndividual, obtenerItemsIndividual, cancelarCompraIndividual } from "./../../../ducks/finanzasDuck"
import MoneyIcon from '@material-ui/icons/Money';
import { formatDinero } from "./../../../utils/formatDinero"
import PickerMod from "../../../global/PickersMod";
import { FormatoFecha, FormatoFechaIso } from "../../../utils/FormatFecha";
import ButtonClienteDetalle from "../../../global/ButtonClienteDetalle";
import {offLoadAction, onLoadAnction} from "../../../ducks/loadDuck"
const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Monto es requerido"),
});
const InitialValues = {
    monto: 1
}
const Formulario = (props) => {
    const {
        open = true,
        setOpen = () => { },
        Compra = {}
    } = props
    const dispatch = useDispatch()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const classes = FPagarItemStyle()
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const [fechaPago, setFechaPago] = useState(new Date())
    const formik = useFormik({
        initialValues: InitialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSend(values)
        },
    })
    const handleCancel = () => {
        DialogMessage.fire({
            title: '¿Esta seguro de marcar este item como cancelado?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({message: ''}))
                dispatch(cancelarCompraIndividual({
                    idCompra: Compra.idCompra,
                })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: Response?.Message,
                        });
                        return null
                    }
                    handleClose();
                    dispatch(obtenerItemsIndividual())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }
    const onSend = (values) => {
        DialogMessage.fire({
            title: '¿Esta seguro de marcar este item como pagado?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({message: ''}))
                dispatch(pagarCompraIndividual({
                    idCompra: Compra.idCompra,
                    TipoCambio: values.monto,
                    fechaPago: FormatoFecha({ date: fechaPago, formato: "MMddyyyy" }),
                })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: Response?.Message,
                        });
                        return null
                    }
                    handleClose();
                    dispatch(obtenerItemsIndividual())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    const handleClose = () => {
        setOpen(false)
        formik.resetForm(InitialValues);
    }

    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }

    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Pagar Item"
            />
            <form onSubmit={formik.handleSubmit}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={6}>
                        <div style={{ display: "flex", flexFlow: "row", justifyContent: "center", alignItems: "flex-start", gap: "1rem" }}>
                            <div style={{ margin: '0 10px' }}>
                                <p>Referencia: <ButtonClienteDetalle referencia={`${Compra.meta.Referencia}`} /></p>
                                {
                                    (Compra.meta?.contratacion?.Cliente) &&
                                    <p>Cliente: <b>{`${Compra.meta?.contratacion?.Cliente}`}</b></p>
                                }
                                <p>Ahorro: <b>{`${formatDinero(Compra.paquete?.Cotizacion?.Suma)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</b></p>
                                <p>Paquete: <b>{`${Compra.paquete?.Nombre}`}</b></p>
                                <p>Monto: <b>{`${formatDinero(Compra.paquete?.Monto_Paquete)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</b></p>
                                <p>Fecha salida: <b>{`${FormatoFechaIso({ date: Compra.paquete?.Fecha_Viaje, formato: 'dd/MM/yyyy' })}`}</b></p>
                                <p>Fecha regreso: <b>{`${FormatoFechaIso({ date: Compra.paquete?.FechaRegreso, formato: 'dd/MM/yyyy' })}`}</b></p>
                                <p>No. Pax: <b>{`${Compra.paquete?.Numero_Personas}`}</b></p>
                            </div>
                            <div style={{ margin: '0 10px' }}>
                                <p>Motivo: <b>{`${Compra.TipoCompra?.Descripcion}`}</b></p>
                                <p>Operador: <b>{`${Compra.paquete?.Proveedor}`}</b></p>
                                <p>Monto proveedor: <b>{`${formatDinero(Compra.MontoProveedor)} ${Compra.paquete?.MonedaProveedor?.Clave}`}</b></p>
                                {
                                    (Compra.paquete?.Cotizacion?.Moneda?.id_moneda !== Compra.paquete?.MonedaProveedor?.id_moneda) &&
                                    <p>Monto Cuenta: <b>{`${formatDinero(Compra.MontoCuenta)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</b></p>
                                }
                                <p>Utilidad: <b>{`${formatDinero(Compra?.paquete?.Utilidad)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</b></p>
                                {
                                    (Compra.paquete?.Cotizacion?.Moneda?.id_moneda !== Compra.paquete?.MonedaProveedor?.id_moneda) ?
                                        <p>Monto final: <b>{`${formatDinero(Compra.MontoCuenta + Compra?.paquete?.Utilidad)}`} MXN</b></p>
                                        :
                                        <p>Monto final: <b>{`${formatDinero(Compra.MontoProveedor + Compra?.paquete?.Utilidad)} ${Compra.paquete?.MonedaProveedor?.Clave}`}</b></p>
                                }
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        {
                            (Compra.lMontos) ?
                                <div>
                                    <p style={{ margin: "0", padding: "0", fontSize: "0.7rem" }}>Desglose por unidad</p>
                                    <TableContainer component={Paper} style={{ overflowY: "scroll", maxHeight: "250px" }}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ minWidth: 50 }}>
                                                        Nombre
                                                    </TableCell>
                                                    <TableCell align="center" style={{ minWidth: 50 }}>
                                                        Precio
                                                    </TableCell>
                                                    <TableCell align="center" style={{ minWidth: 50 }}>
                                                        %
                                                    </TableCell>
                                                    <TableCell align="center" style={{ minWidth: 50 }}>
                                                        Utilidad
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Compra.lMontos.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center" scope="row">
                                                            <p style={{ fontSize: "0.7rem" }}>{row.Nombre}</p>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <p style={{ fontSize: "0.7rem" }}>{`${formatDinero(row.Precio)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</p>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <p style={{ fontSize: "0.7rem" }}>{`${row.Porcentaje}%`}</p>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <p style={{ fontSize: "0.7rem" }}>{`${formatDinero(row.Ganancia)} ${Compra.paquete?.Cotizacion?.Moneda?.Clave}`}</p>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>

                                : <p>No hay desglose de montos disponible</p>
                        }

                    </Grid>
                    {
                        (false) &&
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    }
                    <Grid item xs={6} style={{ marginTop: "0.8rem" }}>
                        <TextField
                            required
                            id="input-Monto"
                            label="T.C. Al momento del pago:"
                            type="text"
                            variant="outlined"
                            name="monto"
                            value={formik.values.monto}
                            onChange={formik.handleChange}
                            error={formik.touched.monto && Boolean(formik.errors.monto)}
                            helperText={formik.touched.monto && formik.errors.monto}
                            className={classes.textField}
                            disabled={(Compra.paquete?.Cotizacion?.Moneda?.id_moneda !== Compra.paquete?.MonedaProveedor?.id_moneda)}
                        />
                    </Grid>
                    <Grid item xs={6} style={{ marginTop: "0.7rem" }}>
                        <PickerMod
                            label="Fecha de pago"
                            setSelectedDate={setFechaPago}
                            disableFuture={true}
                            disablePast={false}
                            selectedDate={fechaPago}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Pagar
                        </Button>
                        <Button
                            onClick={handleCancel}
                            variant="contained"
                            className={classes.modalBoton}
                        >
                            Cancelar compra
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </ModalBase>
    )
}
const FPagarItem = (props) => {
    const { Compra } = props
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton variant="outlined" onClick={onClick}>
                <MoneyIcon color="secondary" />
            </IconButton>
            <Formulario
                Compra={Compra}
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default FPagarItem
